// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_951d299","status":"_cd65e19","team":"_e4ad99c","teamA":"_70b138c","teamB":"_8c4b5be","darkBackground":"_d460703"};